// Global Instructions Rule Applied!
//
// The calling user's rights (docs/USER_RIGHTS_DESIGN.md), as delivered in
// globalConfigs.capabilities by /global-configs from public.view__my_capabilities:
// one entry per capability, with its per-record overrides. `reason` is present
// only where `allowed` is false; an override's reason keeps the literal
// '{record}' for the screen to fill with the label it shows.
//
// A display hint only: public.require_capability() enforces every right in the
// database. Plain string ids, not .uuid(), so a row can never blank the whole
// globalConfigs slice.
import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const CapabilityOverrideModelSchema = z
  .object({
    scope_id: z.string(),
    allowed: z.boolean(),
    reason: z.string().optional()
  })
  .strict()

export const CapabilityGrantModelSchema = z
  .object({
    capability_key: z.string(),
    name: z.string(),
    allowed: z.boolean(),
    reason: z.string().optional(),
    overrides: z.array(CapabilityOverrideModelSchema)
  })
  .strict()

export const CapabilityGrantModelFields = makeFieldKeys(CapabilityGrantModelSchema)

export type CapabilityOverrideModel = z.infer<typeof CapabilityOverrideModelSchema>
export type CapabilityGrantModel = z.infer<typeof CapabilityGrantModelSchema>
